export class UILayerManager {
    constructor(mapInstance, loadedLayersArray) {
        this.map = mapInstance;
        this.loadedLayers = loadedLayersArray;
    }
}
